/**
 * 予期せぬエラーが発生したことを知らせるコンポーネント
 * @returns 
 */
export const ErrorPage = () => {
    return (
        <h5><center>予期しないエラーが発生しました。</center></h5>
    )
};